import type React from 'react';

import type { TransitionCopy } from './transition-users-modal.constants';

interface TransitionConfirmStepProps {
  copy: TransitionCopy;
}

const TransitionConfirmStep = ({
  copy,
}: TransitionConfirmStepProps): React.JSX.Element => (
  <div className="mt-1">{copy.body}</div>
);

export default TransitionConfirmStep;
